// compelete-look-section-product-page-js
const combo = document.getElementById('comboInline');
const container = combo.querySelector('.combo-products');
const comboTotal = document.getElementById('comboTotal');
const comboCompare = document.getElementById('comboCompare');
const comboCount = document.getElementById('comboCount');

/* OPEN COMBO */
document.querySelector('.open-combo').addEventListener('click', function () {
  combo.classList.toggle('active');
  container.innerHTML = '';

  document.querySelectorAll('.look-product-card').forEach(card => {
    container.innerHTML += `
      <div class="combo-product" data-url="${card.dataset.url}">
        <img src="${card.dataset.img}" class="combo-link">

        <div class="combo-info">
          <div class="combo-title combo-link">${card.dataset.title}</div>

          <div class="combo-prices">
            ${parseInt(card.dataset.compare) > parseInt(card.dataset.price)
              ? `<del>₹${(card.dataset.compare/100).toLocaleString()}</del>`
              : ''
            }
            <span>₹${(card.dataset.price/100).toLocaleString()}</span>
          </div>
        </div>

        <input type="checkbox"
          checked
          data-id="${card.dataset.id}"
          data-price="${card.dataset.price}"
          data-compare="${card.dataset.compare}">
      </div>
    `;
  });

  updateComboTotals();
});

/* IMAGE / TITLE CLICK → PRODUCT PAGE */
container.addEventListener('click', function (e) {
  if (!e.target.classList.contains('combo-link')) return;

  const product = e.target.closest('.combo-product');
  if (!product) return;

  window.location.href = product.dataset.url;
});

/* RECALCULATE ON CHECKBOX CHANGE */
container.addEventListener('change', function (e) {
  if (e.target.type === 'checkbox') {
    updateComboTotals();
  }
});

/* UPDATE TOTALS + COUNT */
function updateComboTotals() {
  let total = 0;
  let totalCompare = 0;
  let count = 0;

  document.querySelectorAll('.combo-product input:checked').forEach(i => {
    total += parseInt(i.dataset.price);
    totalCompare += parseInt(i.dataset.compare);
    count++;
  });

  comboTotal.innerText = '₹' + (total/100).toLocaleString();
  comboCompare.innerText = '₹' + (totalCompare/100).toLocaleString();
  comboCount.innerText = `Total Price (${count} items)`;
}

/* BUY NOW → ONLY CHECKED ITEMS */
document.querySelector('.combo-buy-now').addEventListener('click', async function () {
  const items = [];

  document.querySelectorAll('.combo-product input:checked').forEach(i => {
    items.push({
      id: i.dataset.id,
      quantity: 1
    });
  });

  if (!items.length) return;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const res = await fetch('/?sections=cart-drawer');
    const sections = await res.json();

    const newDrawerHTML = sections['cart-drawer'];
    const drawerContainer = document.querySelector('cart-drawer');

    if (drawerContainer && newDrawerHTML) {
      drawerContainer.outerHTML = newDrawerHTML;
    }

    setTimeout(() => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open();
    }, 100);

  } catch (e) {
    console.error('Combo Buy Now error:', e);
  }
});

/* CLOSE */
document.querySelector('.combo-close').addEventListener('click', function () {
  combo.classList.remove('active');
});

/* COPY COUPON */
document.querySelector('.combo-offer').addEventListener('click', function () {
  const code = 'COMBO25';

  navigator.clipboard.writeText(code).then(() => {
    this.classList.add('copied');
    setTimeout(() => this.classList.remove('copied'), 1500);
  });
});

const shopLookBtn = document.querySelector('.open-combo');
if (shopLookBtn) {
  shopLookBtn.innerHTML = shopLookBtn.innerHTML.replace(/\b\d+:\s*/g, '');
}

const comboCodeEl = document.getElementById('comboCode');
const originalText = comboCodeEl.innerText;

comboCodeEl.addEventListener('click', function (e) {
  e.stopPropagation(); 

  navigator.clipboard.writeText(originalText).then(() => {
    comboCodeEl.innerText = 'Copied!';
    comboCodeEl.classList.add('copied');

    setTimeout(() => {
      comboCodeEl.innerText = originalText;
      comboCodeEl.classList.remove('copied');
    }, 1500);
  });
});
// compelete-look-section-product-page-js-end 